// Hero Section Images
export const heroImages = {
  slide1: '/images/hero/business-success.webp',
  slide2: '/images/hero/modern-success.webp',
  slide3: '/images/hero/business-planning.webp',
  slide4: '/images/hero/market-research.webp',
  slide5: '/images/hero/financial-consult.webp',
  overlay: '/images/hero/cta-bg.webp'
};

// Service Section Images
export const serviceImages = {
  applicationDev: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&q=80&w=800',
  softwareTesting: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=800',
  itConsulting: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=800',
  erpImplementation: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=800',
  digitalMarketing: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?auto=format&fit=crop&q=80&w=800'
};

// About Section Images
export const aboutImages = {
  mission: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=800",  // Corporate team success/achievement image
  values: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=800",  // Team collaboration/corporate culture
  whyChooseUs: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&q=80&w=800",  // Modern office/professional workspace
  cta: "https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&q=80&w=800"  // Business growth/success visualization
};

// Contact Section Images
export const contactImages = {
  office: 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=1920',
  support: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?auto=format&fit=crop&q=80&w=800'
};

// Technology Icons
export const techIcons = {
  react: '/images/tech/react.svg',
  angular: '/images/tech/angular.svg',
  node: '/images/tech/node.svg',
  python: '/images/tech/python.svg',
  java: '/images/tech/java.svg',
  aws: '/images/tech/aws.svg',
  docker: '/images/tech/docker.svg',
  kubernetes: '/images/tech/kubernetes.svg'
};

// Brand Logos
export const brandLogos = {
  microsoft: '/images/brands/microsoft.svg',
  google: '/images/brands/google.svg',
  amazon: '/images/brands/amazon.svg',
  ibm: '/images/brands/ibm.svg',
  oracle: '/images/brands/oracle.svg',
  samsung: '/images/brands/samsung.svg'
}; 